module.exports = __webpack_public_path__ + "de8fcc644848bd8e5f31c99bd28844d5.png";